import axios from "axios";
import TokenService from "./token.service";
import localdataService from "./localdata.service";
// import { useLocation } from "react-router-dom";
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + token; // for Spring Boot back-end
      //config.headers["x-access-token"] = token; // for Node.js Express back-end
      const bp_id = localdataService.getDefaultBp();
      if (bp_id) {
        config.headers["x-bp"] = bp_id.bp_id;
        config.headers["x-bp_br"] = bp_id.bp_br_id;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    // console.log(res);
    if (res.headers["x-jwt"] !== undefined)
      TokenService.updateLocalAccessToken(res.headers["x-jwt"]);
    return res;
  },
  (err) => {
    console.log(err);
    if (err?.response?.status === 401) {
      // const location = useLocation();

      TokenService.removeUser();
      window.location = `/auth/login`;
    } else {
      return Promise.reject(err);
      //       toast.error(err.message);
      //       console.log(err);
      //       return false;
      //
    }
  }
);

export default instance;
